import { IFormService } from "../../service/form/FormService";

export default class GetReferenceValueListInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(
    applicantId: number,
    attributeCode: string,
    formQualifierId?: number,
    formTypeCode?: string,
    qualifierCode?: string,
    attributeId?: number,
    reportingPeriodId?: number
  ) {
    return this.formService.getReferenceValueList(
      applicantId,
      attributeCode,
      formQualifierId,
      formTypeCode,
      qualifierCode,
      attributeId,
      reportingPeriodId
    );
  }
}
